import { render, staticRenderFns } from "./ViewTouristicObjects.vue?vue&type=template&id=9c95eda8&"
import script from "./ViewTouristicObjects.vue?vue&type=script&lang=js&"
export * from "./ViewTouristicObjects.vue?vue&type=script&lang=js&"
import style0 from "./ViewTouristicObjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports